import { useState } from 'react';
// Components/ui
import {
  AddressInput,
  InformationItemContainer,
  InformationItemInputsContainer,
  NoteDeleteButton,
  WarningsDisplay,
} from '../../../../../../layout';
// Types
import { NewAddress } from '../../../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';
import { Box } from '@mui/material';
import mailStyle from './style';
import { useEditEntity } from '../../../../../../../../../../../context/EditEntityContext';

type Props = {
  data: NewAddress | IContactAddress;
};

const Mail = ({ data }: Props) => {
  const mode = 'edit';
  const { editEntity } = useEditEntity();
  const editEntityActions = editEntity.action;
  const editEntityState = editEntity.state;
  const [warnings, setWarnings] = useState<string[]>([]);
  const [existingContactId, setExistingContactId] = useState<string | null>(null);

  return (
    <InformationItemContainer>
      <InformationItemInputsContainer>
        <Box sx={mailStyle.numberCountryContainer}>
          <Box sx={mailStyle.adressInputBox}>
            <AddressInput
              data={data}
              setWarnings={setWarnings}
              setExistingContactId={setExistingContactId}
              onChange={editEntityActions.handleAddressFieldChange}
            />
          </Box>
        </Box>
        <NoteDeleteButton
          mode={mode}
          addressData={data}
          handleNoteFieldChange={editEntityActions.handleNoteFieldChange}
          handleDeleteAddress={editEntityActions.handleDeleteAddress}
          isDeletingAddress={editEntityState.isDeletingAddress}
          replaceAddress={editEntityActions.replaceAddress}
        />
      </InformationItemInputsContainer>
      {warnings.length > 0 && (
        <WarningsDisplay warnings={warnings} existingContactId={existingContactId} />
      )}
    </InformationItemContainer>
  );
};

export default Mail;
